module.exports = __webpack_public_path__ + "static/media/guitar.c8172939.png";